import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {MenuService} from './menu.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MenuItemLocal} from './menu-item.model';
import {ApiList} from '../../API/api-list.enum';
import _ from 'lodash';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../shared/services/auth.service';
import {DomSanitizer} from '@angular/platform-browser';
import {FavoritesApiService} from '../../../../projects/api/src/favorite/favorites-api.service';
import {FavoriteModel, FavoriteType} from '../../../../projects/api/src/favorite/favorite.model';
import {InsparkMessageService} from '@inspark/inspark-components';
import {ConnectionPositionPair, CdkConnectedOverlay} from '@angular/cdk/overlay';
import {ApplicationsApiService} from '../../../../projects/api/src/applications/applications-api.service';
import {ApplicationModel} from '../../../../projects/api/src/applications/application.model';
import {ConfigureService} from '../../../../projects/common/modules/configure/configure.service';
import {MainTempService} from '../main-temp.service';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';

const DESKTOP_WIDTH = 1200;

export const customIcons = [
  {
    iconName: 'settings-etl',
    iconData: `<svg width='18' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M19.7452 12.5524L21.719 13.6435C21.946 13.7677 22.048 14.025 21.9785 14.2689C21.898 14.5165 21.8088 14.7603 21.7111 15H11C10.4477 15 10 15.4477 10 16V21C10 21.5517 10.4468 21.9991 10.9984 22C10.1596 21.9998 9.31087 21.9132 8.47232 21.7338C8.21749 21.6806 8.03679 21.4633 8.03679 21.2149V19.0326C7.00356 18.6867 6.04909 18.1588 5.21973 17.4758L3.24593 18.5669C3.02353 18.6911 2.73626 18.6467 2.5602 18.4649C1.41576 17.2762 0.540066 15.848 0.0257668 14.2689C-0.0483664 14.0294 0.0535668 13.7722 0.2806 13.648L2.2544 12.5568C2.05516 11.5278 2.05516 10.4722 2.2544 9.44315L0.2806 8.35203C0.0535668 8.22783 -0.0529997 7.97058 0.0257668 7.73106C0.540066 6.1476 1.41576 4.71938 2.5602 3.53511C2.73626 3.34882 3.0189 3.3089 3.24593 3.43309L5.21509 4.52422C6.04909 3.84559 7.00356 3.31777 8.03215 2.96737V0.785119C8.03215 0.536733 8.21285 0.319395 8.46769 0.26617C10.0847 -0.0797969 11.8268 -0.0975387 13.5273 0.26617C13.7821 0.319395 13.9628 0.536733 13.9628 0.785119V2.96293C14.996 3.3089 15.9505 3.83672 16.7799 4.51978L18.7537 3.42866C18.9761 3.30446 19.2633 3.34882 19.4394 3.53067C20.5838 4.71938 21.4595 6.1476 21.9738 7.72663C22.048 7.96614 21.946 8.2234 21.719 8.34759L19.7452 9.43871C19.9444 10.4677 19.9444 11.5234 19.7452 12.5524ZM7.29082 10.9956C7.29082 12.9516 8.95419 14.5439 10.9975 14.5439C13.0408 14.5439 14.7041 12.9516 14.7041 10.9956C14.7041 9.03952 13.0408 7.44719 10.9975 7.44719C8.95419 7.44719 7.29082 9.03952 7.29082 10.9956Z' fill=\'currentColor\'/>
      <path d='M13.8613 21H11V16H13.8613V16.8687H12.0534V17.9665H13.7356V18.8352H12.0534V20.1245H13.8613V21Z' fill=\'currentColor\'/>
      <path d='M16.8177 21H15.7643V16.8824H14.4152V16H18.1668V16.8824H16.8177V21Z' fill=\'currentColor\'/>
      <path d='M18.9314 21V16H19.9849V20.1245H22V21H18.9314Z' fill=\'currentColor\'/>
      </svg>`
  },
  {
    iconName: 'tag',
    iconData: `<svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M3 16L4 12H0.5L1 10H4.5L5.5 6H1.5L2 4H6L7 0H9L8 4H12L13 0H15L14 4H17.5L17 6H13.5L12.5 10H16.5L16 12H12L11 16H9L10 12H6L5 16H3ZM6.5 10H10.5L11.5 6H7.5L6.5 10Z' fill='currentColor'/>
        </svg>`
  },
  {
    iconName: 'setup-export',
    iconData: `<svg width='18' height='22' viewBox='0 0 22 22'  xmlns='http://www.w3.org/2000/svg'>
      <path fill='currentColor' clip-rule='evenodd' d='M19 8L23 12L19 16V13H15V11H19V8ZM15 9H17V6C17 5.46957 16.7893 4.96086 16.4142 4.58579C16.0391 4.21071 15.5304 4 15 4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V18C1 18.5304 1.21071 19.0391 1.58579 19.4142C1.96086 19.7893 2.46957 20 3 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V15H15V18H3V6H15V9Z'/>
      <path fill='currentColor' d='M13.2967 13.0563L12.508 12.6203C12.5876 12.2091 12.5876 11.7873 12.508 11.3761L13.2967 10.9401C13.3874 10.8905 13.4282 10.7877 13.3985 10.6919C13.193 10.061 12.8431 9.49027 12.3858 9.01527C12.3154 8.9426 12.2007 8.92488 12.1118 8.9745L11.3231 9.41051C10.9917 9.13756 10.6103 8.92665 10.1974 8.7884V7.91816C10.1974 7.81891 10.1252 7.73206 10.0233 7.71079C9.34387 7.56546 8.64772 7.57254 8.00156 7.71079C7.89973 7.73206 7.82753 7.81891 7.82753 7.91816V8.79018C7.4165 8.93019 7.0351 9.14111 6.70184 9.41228L5.91498 8.97628C5.82425 8.92665 5.71132 8.9426 5.64096 9.01704C5.18365 9.49027 4.83373 10.061 4.62822 10.6937C4.59674 10.7894 4.63932 10.8922 4.73005 10.9419L5.51876 11.3779C5.43915 11.7891 5.43915 12.2109 5.51876 12.6221L4.73005 13.0581C4.63932 13.1077 4.59859 13.2105 4.62822 13.3062C4.83373 13.9372 5.18365 14.5079 5.64096 14.9829C5.71132 15.0556 5.82611 15.0733 5.91498 15.0237L6.70369 14.5877C7.0351 14.8606 7.4165 15.0715 7.82938 15.2098V16.0818C7.82938 16.181 7.90158 16.2679 8.00341 16.2892C8.6829 16.4345 9.37904 16.4274 10.0252 16.2892C10.127 16.2679 10.1992 16.181 10.1992 16.0818V15.2098C10.6103 15.0698 10.9917 14.8588 11.3249 14.5877L12.1136 15.0237C12.2044 15.0733 12.3173 15.0573 12.3877 14.9829C12.845 14.5097 13.1949 13.939 13.4004 13.3062C13.4282 13.2087 13.3874 13.1059 13.2967 13.0563ZM9.01246 13.4161C8.19597 13.4161 7.53129 12.7798 7.53129 11.9982C7.53129 11.2166 8.19597 10.5803 9.01246 10.5803C9.82895 10.5803 10.4936 11.2166 10.4936 11.9982C10.4936 12.7798 9.82895 13.4161 9.01246 13.4161Z'/>
      </svg>`
  },
  {
    iconName: 'export-errors',
    iconData: `<svg width='18' height='16' viewBox='0 0 22 16' xmlns='http://www.w3.org/2000/svg'>
          <path fill='currentColor' d='M18 4L22 8L18 12V9H14V7H18V4Z' />
          <path fill='currentColor' d='M14 5H16V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V11H14V14H2V2H14V5Z' />
          <path fill='currentColor' d='M8.01343 10C8.12676 10 8.22183 9.9616 8.29863 9.8848C8.37543 9.808 8.41369 9.71307 8.41343 9.6C8.41343 9.48667 8.37503 9.3916 8.29823 9.3148C8.22143 9.238 8.12649 9.19973 8.01343 9.2C7.90009 9.2 7.80503 9.2384 7.72823 9.3152C7.65143 9.392 7.61316 9.48693 7.61343 9.6C7.61343 9.71333 7.65183 9.8084 7.72863 9.8852C7.80543 9.962 7.90036 10.0003 8.01343 10ZM7.61343 8.4H8.41343V6H7.61343V8.4ZM8.01343 12C7.46009 12 6.94009 11.8949 6.45343 11.6848C5.96676 11.4747 5.54343 11.1897 5.18343 10.83C4.82343 10.47 4.53849 10.0467 4.32863 9.56C4.11876 9.07333 4.01369 8.55333 4.01343 8C4.01343 7.44667 4.11849 6.92667 4.32863 6.44C4.53876 5.95333 4.82369 5.53 5.18343 5.17C5.54343 4.81 5.96676 4.52507 6.45343 4.3152C6.94009 4.10533 7.46009 4.00027 8.01343 4C8.56676 4 9.08676 4.10507 9.57343 4.3152C10.0601 4.52533 10.4834 4.81027 10.8434 5.17C11.2034 5.53 11.4885 5.95333 11.6986 6.44C11.9088 6.92667 12.0137 7.44667 12.0134 8C12.0134 8.55333 11.9084 9.07333 11.6982 9.56C11.4881 10.0467 11.2032 10.47 10.8434 10.83C10.4834 11.19 10.0601 11.4751 9.57343 11.6852C9.08676 11.8953 8.56676 12.0003 8.01343 12Z' />
          </svg>`
  },
  {
    iconName: 'report-finance',
    iconData: `<svg width='18' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3 13.5L0 16.44V8H3M8 11.66L6.43 10.32L5 11.64V4H8M13 10L10 13V0H13M15.81 9.81L14 8H19V13L17.21 11.21L10 18.36L6.53 15.34L2.75 19H0L6.47 12.66L10 15.64' fill='currentColor'/>
      </svg>`
  },
  {
    iconName: 'cpu-settings',
    iconData: `<svg width='18' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6 6H12V8.49816C11.2524 8.80993 10.5755 9.25731 10 9.80957V8H8V10H9.80957C9.25731 10.5755 8.80993 11.2524 8.49816 12H6V6Z' fill='currentColor'/>
    <path d='M8.01894 14H4V4H14V8.01894C14.165 8.00639 14.3318 8 14.5 8C15.0163 8 15.5185 8.06019 16 8.17393V8H18V6H16V4C16 2.9 15.1 2 14 2H12V0H10V2H8V0H6V2H4C2.9 2 2 2.9 2 4V6H0V8H2V10H0V12H2V14C2 15.1 2.9 16 4 16H6V18H8V16H8.17393C8.06019 15.5185 8 15.0163 8 14.5C8 14.3318 8.00639 14.165 8.01894 14Z' fill='currentColor'/>
    <path d='M18.885 15.5814L18.0776 15.1351C18.1591 14.7141 18.1591 14.2823 18.0776 13.8613L18.885 13.4149C18.9779 13.3641 19.0196 13.2589 18.9893 13.1609C18.7789 12.5149 18.4207 11.9307 17.9525 11.4444C17.8805 11.37 17.7629 11.3518 17.672 11.4026L16.8645 11.849C16.5252 11.5696 16.1347 11.3536 15.7121 11.2121V10.3212C15.7121 10.2196 15.6381 10.1307 15.5339 10.1089C14.8383 9.9601 14.1256 9.96736 13.4641 10.1089C13.3598 10.1307 13.2859 10.2196 13.2859 10.3212V11.2139C12.8651 11.3573 12.4746 11.5732 12.1334 11.8508L11.3279 11.4044C11.235 11.3536 11.1194 11.37 11.0474 11.4462C10.5792 11.9307 10.2209 12.5149 10.0105 13.1627C9.97832 13.2607 10.0219 13.3659 10.1148 13.4167L10.9223 13.8631C10.8407 14.2841 10.8407 14.7159 10.9223 15.1369L10.1148 15.5833C10.0219 15.6341 9.98021 15.7393 10.0105 15.8373C10.2209 16.4833 10.5792 17.0675 11.0474 17.5538C11.1194 17.6282 11.2369 17.6464 11.3279 17.5956L12.1353 17.1492C12.4746 17.4286 12.8651 17.6445 13.2878 17.7861V18.6788C13.2878 18.7804 13.3617 18.8693 13.4659 18.8911C14.1616 19.0399 14.8743 19.0326 15.5358 18.8911C15.64 18.8693 15.714 18.7804 15.714 18.6788V17.7861C16.1347 17.6427 16.5252 17.4268 16.8664 17.1492L17.6739 17.5956C17.7667 17.6464 17.8824 17.63 17.9544 17.5538C18.4226 17.0693 18.7808 16.4851 18.9912 15.8373C19.0196 15.7375 18.9779 15.6323 18.885 15.5814ZM14.499 15.9498C13.6631 15.9498 12.9826 15.2984 12.9826 14.4982C12.9826 13.698 13.6631 13.0466 14.499 13.0466C15.3349 13.0466 16.0153 13.698 16.0153 14.4982C16.0153 15.2984 15.3349 15.9498 14.499 15.9498Z' fill='currentColor'/>
    </svg>
    `
  },
  {
    iconName: 'arrow-range',
    iconData: `<svg width='18' height='10' viewBox='0 0 20 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M5 10L0 5L5 0L6.4 1.425L3.825 4H16.15L13.575 1.425L15 0L20 5L15 10L13.575 8.6L16.15 6H3.825L6.4 8.6L5 10Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'list',
    iconData: `<svg width='18' height='10' viewBox='0 0 18 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1 10C0.71667 10 0.479003 9.904 0.287003 9.712C0.0950034 9.52 -0.000663206 9.28267 3.46021e-06 9C3.46021e-06 8.71667 0.0960036 8.479 0.288004 8.287C0.480004 8.095 0.717337 7.99934 1 8C1.28334 8 1.521 8.096 1.713 8.288C1.905 8.48 2.00067 8.71734 2 9C2 9.28334 1.904 9.521 1.712 9.713C1.52 9.905 1.28267 10.0007 1 10ZM1 6C0.71667 6 0.479003 5.904 0.287003 5.712C0.0950034 5.52 -0.000663206 5.28267 3.46021e-06 5C3.46021e-06 4.71667 0.0960036 4.479 0.288004 4.287C0.480004 4.095 0.717337 3.99934 1 4C1.28334 4 1.521 4.096 1.713 4.288C1.905 4.48 2.00067 4.71734 2 5C2 5.28334 1.904 5.521 1.712 5.713C1.52 5.905 1.28267 6.00067 1 6ZM1 2C0.71667 2 0.479003 1.904 0.287003 1.712C0.0950034 1.52 -0.000663206 1.28267 3.46021e-06 1C3.46021e-06 0.71667 0.0960036 0.479004 0.288004 0.287004C0.480004 0.0950036 0.717337 -0.000663206 1 3.4602e-06C1.28334 3.4602e-06 1.521 0.0960036 1.713 0.288004C1.905 0.480004 2.00067 0.717337 2 1C2 1.28334 1.904 1.521 1.712 1.713C1.52 1.905 1.28267 2.00067 1 2ZM4 10V8H18V10H4ZM4 6V4H18V6H4ZM4 2V3.4602e-06H18V2H4Z' fill='currentColor'/>
        </svg>`
  },
  {
    iconName: 'list-status',
    iconData: `<svg width='18' height='16' viewBox='0 0 21 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M14.5 7L11 3.5L12.4 2.1L14.5 4.2L18.7 0L20.1 1.4L14.5 7ZM9 3H0V5H9V3ZM19 9.4L17.6 8L15 10.6L12.4 8L11 9.4L13.6 12L11 14.6L12.4 16L15 13.4L17.6 16L19 14.6L16.4 12L19 9.4ZM9 11H0V13H9V11Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'calendar-clock',
    iconData: `<svg width='18' height='22' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M12 12H13.5V14.82L15.94 16.23L15.19 17.53L12 15.69V12ZM16 7H2V18H6.67C6.24 17.09 6 16.07 6 15C6 13.1435 6.7375 11.363 8.05025 10.0503C9.36301 8.7375 11.1435 8 13 8C14.07 8 15.09 8.24 16 8.67V7ZM2 20C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V4C0 2.89 0.89 2 2 2H3V0H5V2H13V0H15V2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V10.1C19.24 11.36 20 13.09 20 15C20 16.8565 19.2625 18.637 17.9497 19.9497C16.637 21.2625 14.8565 22 13 22C11.09 22 9.36 21.24 8.1 20H2ZM13 10.15C11.7137 10.15 10.4801 10.661 9.57053 11.5705C8.66098 12.4801 8.15 13.7137 8.15 15C8.15 17.68 10.32 19.85 13 19.85C13.6369 19.85 14.2676 19.7246 14.856 19.4808C15.4444 19.2371 15.9791 18.8798 16.4295 18.4295C16.8798 17.9791 17.2371 17.4444 17.4808 16.856C17.7246 16.2676 17.85 15.6369 17.85 15C17.85 12.32 15.68 10.15 13 10.15Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'activity-zone',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M3 20C2.16667 20 1.45834 19.7083 0.875002 19.125C0.291668 18.5417 1.77305e-06 17.8333 1.77305e-06 17C1.77305e-06 16.35 0.187668 15.7707 0.563002 15.262C0.938335 14.7533 1.41734 14.391 2 14.175V5.825C1.41667 5.60834 0.937335 5.24567 0.562002 4.737C0.186668 4.22834 -0.000664894 3.64933 1.77305e-06 3C1.77305e-06 2.16667 0.291668 1.45834 0.875002 0.875002C1.45834 0.291668 2.16667 1.77305e-06 3 1.77305e-06C3.65 1.77305e-06 4.22934 0.187668 4.738 0.563002C5.24667 0.938335 5.60867 1.41734 5.824 2H14.174C14.374 1.41667 14.7283 0.937335 15.237 0.562002C15.7457 0.186668 16.3333 -0.000664894 17 1.77305e-06C17.8333 1.77305e-06 18.5417 0.291668 19.125 0.875002C19.7083 1.45834 20 2.16667 20 3C20 3.66667 19.8123 4.25434 19.437 4.763C19.0617 5.27167 18.5827 5.62567 18 5.825V14.175C18.5833 14.3917 19.0627 14.7543 19.438 15.263C19.8133 15.7717 20.0007 16.3507 20 17C20 17.8333 19.7083 18.5417 19.125 19.125C18.5417 19.7083 17.8333 20 17 20C16.35 20 15.7707 19.8123 15.262 19.437C14.7533 19.0617 14.391 18.5827 14.175 18H5.825C5.60834 18.5833 5.24567 19.0627 4.737 19.438C4.22834 19.8133 3.64933 20.0007 3 20ZM5.825 16H14.175C14.325 15.5667 14.5583 15.1917 14.875 14.875C15.1917 14.5583 15.5667 14.325 16 14.175V5.825C15.5667 5.675 15.1917 5.44167 14.875 5.125C14.5583 4.80834 14.325 4.43334 14.175 4H5.825C5.675 4.43334 5.44167 4.80834 5.125 5.125C4.80834 5.44167 4.43334 5.675 4 5.825V14.175C4.43334 14.325 4.80834 14.5583 5.125 14.875C5.44167 15.1917 5.675 15.5667 5.825 16Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'selection-marker',
    iconData: `<svg width='18' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H5V2H2V5H0V2ZM20 2V5H18V2H15V0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2ZM0 18V15H2V18H5V20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18ZM8 0H12V2H8V0ZM8 18H12V20H8V18ZM0 8H2V12H0V8ZM16.5 11C18.4 11 20 12.6 20 14.5C20 17.1 16.5 21 16.5 21C16.5 21 13 17.1 13 14.5C13 12.6 14.6 11 16.5 11ZM16.5 15.8C17.2 15.8 17.8 15.2 17.7 14.6C17.7 14 17.1 13.4 16.5 13.4C15.9 13.4 15.3 13.9 15.3 14.6C15.3 15.2 15.8 15.8 16.5 15.8ZM18 8H20V10.34C19.42 9.84 18.74 9.45 18 9.23V8Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'import',
    iconData: `<svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M12 8L8 4V7H0V9H8V12M18 14V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V5H4V2H16V14H4V11H2V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'export',
    iconData: `<svg width='18' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M22 8L18 4V7H9V9H18V12M0 14V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V5H14V2H2V14H14V11H16V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'home-iot-device',
    iconData: `<svg width='18' height='16' viewBox='0 0 22 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
<path d='M4.0249 6H5.0249V2.5C5.0249 2.35 4.9789 2.229 4.8869 2.137C4.7949 2.045 4.67457 1.99933 4.5259 2C4.3759 2 4.2549 2.046 4.1629 2.138C4.0709 2.23 4.02524 2.35067 4.0259 2.5L4.0249 6ZM4.5249 16C3.2749 16 2.21224 15.5667 1.3369 14.7C0.46157 13.8333 0.0242364 12.7667 0.0249031 11.5C0.0249031 10.7 0.208237 9.98333 0.574903 9.35C0.94157 8.71667 1.4249 8.2 2.0249 7.8V2.5C2.0249 1.8 2.26657 1.20833 2.7499 0.725C3.23324 0.241667 3.8249 0 4.5249 0C5.2249 0 5.81657 0.241667 6.2999 0.725C6.78324 1.20833 7.0249 1.8 7.0249 2.5V7.8C7.6249 8.2 8.10824 8.71667 8.4749 9.35C8.84157 9.98333 9.0249 10.7 9.0249 11.5C9.0249 12.75 8.58757 13.8127 7.7129 14.688C6.83824 15.5633 5.77557 16.0007 4.5249 16ZM12.6999 11C11.8999 10.45 11.2499 9.74167 10.7499 8.875C10.2499 8.00833 9.9999 7.05 9.9999 6C9.9999 4.33333 10.5832 2.91667 11.7499 1.75C12.9166 0.583333 14.3332 0 15.9999 0C17.6666 0 19.0832 0.583333 20.2499 1.75C21.4166 2.91667 21.9999 4.33333 21.9999 6C21.9999 7.05 21.7499 8.00833 21.2499 8.875C20.7499 9.74167 20.0999 10.45 19.2999 11H12.6999ZM15.9999 16C15.5999 16 15.2499 15.85 14.9499 15.55C14.6499 15.25 14.4999 14.9 14.4999 14.5H17.4999C17.4999 14.9 17.3499 15.25 17.0499 15.55C16.7499 15.85 16.3999 16 15.9999 16ZM12.9999 14V12H18.9999V14H12.9999Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'cpu',
    iconData: `<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M12 6H6V12H12V6ZM10 10H8V8H10V10ZM18 8V6H16V4C16 2.9 15.1 2 14 2H12V0H10V2H8V0H6V2H4C2.9 2 2 2.9 2 4V6H0V8H2V10H0V12H2V14C2 15.1 2.9 16 4 16H6V18H8V16H10V18H12V16H14C15.1 16 16 15.1 16 14V12H18V10H16V8H18ZM14 14H4V4H14V14Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'file-tree',
    iconData: `<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M0 0H6V4H0V0ZM12 7H18V11H12V7ZM12 14H18V18H12V14ZM10 10H4V15H10V17H2V6H4V8H10V10Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'ethernet',
    iconData: `<svg width='18' height='19' viewBox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M5 12H7V15H9V12H11V15H13V12H15V15H17V6H13V3H7V6H3V15H5V12ZM2.38 0H17.63C17.9421 -2.77793e-06 18.2511 0.0616289 18.5393 0.181357C18.8275 0.301086 19.0892 0.476554 19.3094 0.697689C19.5296 0.918824 19.704 1.18127 19.8225 1.46997C19.941 1.75867 20.0013 2.06793 20 2.38V16.63C20 17.2586 19.7503 17.8614 19.3058 18.3058C18.8614 18.7503 18.2586 19 17.63 19H2.38C2.06793 19.0013 1.75867 18.941 1.46997 18.8225C1.18127 18.704 0.918824 18.5296 0.697689 18.3094C0.476554 18.0892 0.301086 17.8275 0.181357 17.5393C0.0616289 17.2511 -2.77793e-06 16.9421 0 16.63V2.38C0 1.06 1.06 0 2.38 0Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'multimedia',
    iconData: `<svg width='18' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M7 11V3C7 1.9 7.9 1 9 1H18C19.1 1 20 1.9 20 3V9H16.57L15.29 7.26C15.2776 7.23929 15.26 7.22216 15.2389 7.21026C15.2179 7.19836 15.1942 7.19211 15.17 7.19211C15.1458 7.19211 15.1221 7.19836 15.1011 7.21026C15.08 7.22216 15.0624 7.23929 15.05 7.26L13.06 10C13 10.06 12.88 10.07 12.82 10L11.39 8.25C11.3757 8.23349 11.3581 8.22025 11.3382 8.21117C11.3184 8.20209 11.2968 8.19739 11.275 8.19739C11.2532 8.19739 11.2316 8.20209 11.2118 8.21117C11.1919 8.22025 11.1743 8.23349 11.16 8.25L9.05 10.91C8.97 11 9.04 11.15 9.16 11.15H15.5V13H9C7.89 13 7 12.11 7 11ZM4 20V19H2V20H0V0H2V1H4V0H6.39C5.54 0.74 5 1.8 5 3V11C5 13.21 6.79 15 9 15H13.7C12.67 15.83 12 17.08 12 18.5C12 19.03 12.11 19.53 12.28 20H4ZM2 5H4V3H2V5ZM2 9H4V7H2V9ZM2 13H4V11H2V13ZM4 17V15H2V17H4ZM21 11V13H19V18.5C19 19.163 18.7366 19.7989 18.2678 20.2678C17.7989 20.7366 17.163 21 16.5 21C15.837 21 15.2011 20.7366 14.7322 20.2678C14.2634 19.7989 14 19.163 14 18.5C14.0002 18.085 14.1037 17.6766 14.3012 17.3116C14.4987 16.9466 14.784 16.6365 15.1312 16.4093C15.4785 16.1821 15.8769 16.0449 16.2904 16.0101C16.704 15.9753 17.1196 16.044 17.5 16.21V11H21Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'folder-special',
    iconData: `<svg width='18' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M18 2H10L8 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM15.94 13L13 11.28L10.06 13L10.84 9.67L8.25 7.43L11.66 7.14L13 4L14.34 7.14L17.75 7.43L15.16 9.67L15.94 13Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'image-multiple',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M20 14V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0H6C5.46957 0 4.96086 0.210714 4.58579 0.585786C4.21071 0.960859 4 1.46957 4 2V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14ZM9 10L11.03 12.71L14 9L18 14H6M0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16V18H2V4' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'baseline-brush',
    iconData: `<svg width='18' height='19' viewBox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M5 12C3.34 12 2 13.34 2 15C2 16.31 0.84 17 0 17C0.92 18.22 2.49 19 4 19C6.21 19 8 17.21 8 15C8 13.34 6.66 12 5 12ZM18.71 2.63L17.37 1.29C17.2775 1.1973 17.1676 1.12375 17.0466 1.07357C16.9257 1.02339 16.796 0.997559 16.665 0.997559C16.534 0.997559 16.4043 1.02339 16.2834 1.07357C16.1624 1.12375 16.0525 1.1973 15.96 1.29L7 10.25L9.75 13L18.71 4.04C18.8027 3.94749 18.8763 3.8376 18.9264 3.71663C18.9766 3.59565 19.0024 3.46597 19.0024 3.335C19.0024 3.20403 18.9766 3.07435 18.9264 2.95338C18.8763 2.83241 18.8027 2.72252 18.71 2.63Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'temperature-celsius',
    iconData: `<svg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M13.5 2C15.05 2 16.5 2.47 17.69 3.28L16.53 6.17C15.7024 5.41387 14.621 4.99627 13.5 5C11 5 9 7 9 9.5C9 12 11 14 13.5 14C14.53 14 15.47 13.66 16.23 13.08L17.37 15.93C16.2018 16.6332 14.8635 17.0032 13.5 17C11.5109 17 9.60322 16.2098 8.1967 14.8033C6.79018 13.3968 6 11.4891 6 9.5C6 7.51088 6.79018 5.60322 8.1967 4.1967C9.60322 2.79018 11.5109 2 13.5 2ZM3 0C3.79565 0 4.55871 0.316071 5.12132 0.87868C5.68393 1.44129 6 2.20435 6 3C6 3.79565 5.68393 4.55871 5.12132 5.12132C4.55871 5.68393 3.79565 6 3 6C2.20435 6 1.44129 5.68393 0.87868 5.12132C0.316071 4.55871 0 3.79565 0 3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0ZM3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4C3.26522 4 3.51957 3.89464 3.70711 3.70711C3.89464 3.51957 4 3.26522 4 3C4 2.73478 3.89464 2.48043 3.70711 2.29289C3.51957 2.10536 3.26522 2 3 2Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'office-building-marker',
    iconData: `<svg width='17' height='19' viewBox='0 0 17 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M10.19 18C9.12 16.43 8 14.36 8 12.5C8 10.67 8.96 9 10.4 8H10V6H12V7.23C12.5 7.09 13 7 13.5 7C13.67 7 13.84 7 14 7.03V0H0V18H6V14.5H8V18H10.19ZM10 2H12V4H10V2ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM6 2H8V4H6V2ZM6 6H8V8H6V6ZM6 12V10H8V12H6ZM13.5 9C11.6 9 10 10.61 10 12.5C10 15.11 13.5 19 13.5 19C13.5 19 17 15.11 17 12.5C17 10.61 15.4 9 13.5 9ZM13.5 13.81C12.8 13.81 12.3 13.21 12.3 12.61C12.3 11.91 12.9 11.41 13.5 11.41C14.1 11.41 14.7 12 14.7 12.61C14.8 13.21 14.2 13.81 13.5 13.81Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'calendar-multiple',
    iconData: `<svg width='18' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M20 16V7H6V16H20ZM20 2C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H6C5.46957 18 4.96086 17.7893 4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H7V0H9V2H17V0H19V2H20ZM2 20H16V22H2C1.46957 22 0.960859 21.7893 0.585786 21.4142C0.210714 21.0391 0 20.5304 0 20V8H2V20ZM18 14H14V10H18V14Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'problem',
    iconData: `<svg width='18' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M5 12C5.28334 12 5.521 11.904 5.713 11.712C5.905 11.52 6.00067 11.2827 6 11C6 10.7167 5.904 10.479 5.712 10.287C5.52 10.095 5.28267 9.99934 5 10C4.71667 10 4.479 10.096 4.287 10.288C4.095 10.48 3.99934 10.7173 4 11C4 11.2833 4.096 11.521 4.288 11.713C4.48 11.905 4.71734 12.0007 5 12ZM4 9H6V4H4V9ZM8 11H16V9H8V11ZM8 7H16V5H8V7ZM2 16C1.45 16 0.979002 15.804 0.587002 15.412C0.195002 15.02 -0.000664969 14.5493 1.69779e-06 14V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H18C18.55 1.69779e-06 19.021 0.196001 19.413 0.588001C19.805 0.980001 20.0007 1.45067 20 2V14C20 14.55 19.804 15.021 19.412 15.413C19.02 15.805 18.5493 16.0007 18 16H2Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'baseline-key',
    iconData: `<svg width='18' height='12' viewBox='0 0 22 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M20 4H11.65C11.2381 2.83048 10.4733 1.81762 9.46134 1.10116C8.44934 0.384703 7.23994 -4.57935e-05 6 4.08807e-09C2.69 4.08807e-09 0 2.69 0 6C0 9.31 2.69 12 6 12C7.23994 12 8.44934 11.6153 9.46134 10.8988C10.4733 10.1824 11.2381 9.16952 11.65 8H12L14 10L16 8L18 10L22 5.96L20 4ZM6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'users',
    iconData: `<svg width='18' height='15' viewBox='0 0 20 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M14 13V15H0V13C0 13 0 9 7 9C14 9 14 13 14 13ZM10.5 3.5C10.5 2.80777 10.2947 2.13108 9.91014 1.5555C9.52556 0.979932 8.97893 0.531329 8.33939 0.266422C7.69985 0.00151521 6.99612 -0.0677965 6.31718 0.0672518C5.63825 0.2023 5.01461 0.535643 4.52513 1.02513C4.03564 1.51461 3.7023 2.13825 3.56725 2.81718C3.4322 3.49612 3.50152 4.19985 3.76642 4.83939C4.03133 5.47893 4.47993 6.02556 5.0555 6.41014C5.63108 6.79473 6.30777 7 7 7C7.92826 7 8.8185 6.63125 9.47487 5.97487C10.1313 5.3185 10.5 4.42826 10.5 3.5ZM13.94 9C14.5547 9.47575 15.0578 10.0804 15.4137 10.7715C15.7696 11.4626 15.9697 12.2233 16 13V15H20V13C20 13 20 9.37 13.94 9ZM13 1.26915e-07C12.3117 -0.00383259 11.6385 0.201956 11.07 0.59C11.6774 1.43874 12.0041 2.45629 12.0041 3.5C12.0041 4.54371 11.6774 5.56126 11.07 6.41C11.6385 6.79804 12.3117 7.00383 13 7C13.9283 7 14.8185 6.63125 15.4749 5.97487C16.1313 5.3185 16.5 4.42826 16.5 3.5C16.5 2.57174 16.1313 1.6815 15.4749 1.02513C14.8185 0.368749 13.9283 1.26915e-07 13 1.26915e-07Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'math-log',
    iconData: `<svg width='18' height='10' viewBox='0 0 20 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M16 0C14.9 0 14 0.9 14 2V8C14 9.1 14.9 10 16 10H18C19.1 10 20 9.1 20 8V4H18V8H16V2H20V0H16ZM0 0V10H6V8H2V0H0ZM9 0C7.9 0 7 0.9 7 2V8C7 9.1 7.9 10 9 10H11C12.1 10 13 9.1 13 8V2C13 0.9 12.1 0 11 0H9ZM9 2H11V8H9V2Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'commands-log',
    iconData: `<svg width='18' height='23' viewBox='0 0 21 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M11 13H4V15H11M16 18H2V7H16M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM14 9H4V11H14V9Z' fill='currentColor'/>
<path d='M21 16C21 19.866 17.866 23 14 23C10.134 23 7 19.866 7 16C7 12.134 10.134 9 14 9C17.866 9 21 12.134 21 16Z' fill='white'/>
<path d='M12 19L17 16L12 13V19Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'setvalue-log',
    iconData: `<svg width='18' height='23' viewBox='0 0 21 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M11 13H4V15H11M16 18H2V7H16M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM14 9H4V11H14V9Z' fill='currentColor'/>
<path d='M21 16C21 19.866 17.866 23 14 23C10.134 23 7 19.866 7 16C7 12.134 10.134 9 14 9C17.866 9 21 12.134 21 16Z' fill='white'/>
<path d='M12.8692 20L9 15.9859L10.5259 14.4028L12.842 16.8057L17.4741 12L19 13.6113L12.8692 20Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'event-log',
    iconData: `<svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99933 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.021 2.196 17.413 2.588C17.805 2.98 18.0007 3.45067 18 4V18C18 18.55 17.804 19.021 17.412 19.413C17.02 19.805 16.5493 20.0007 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM4 12V10H14V12H4ZM4 16V14H11V16H4Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'notifications-log',
    iconData: `<svg width='18' height='23' viewBox='0 0 21 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M11 13H4V15H11M16 18H2V7H16M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM14 9H4V11H14V9Z' fill='currentColor'/>
<path d='M21 16C21 19.866 17.866 23 14 23C10.134 23 7 19.866 7 16C7 12.134 10.134 9 14 9C17.866 9 21 12.134 21 16Z' fill='white'/>
<path d='M14 21C14.6307 21 15.1423 20.4404 15.1423 19.75H12.8577C12.8577 20.4404 13.3693 21 14 21ZM17.8462 18.076C17.5012 17.6705 16.8557 17.0605 16.8557 15.0625C16.8557 13.5449 15.8829 12.3301 14.5711 12.032V11.625C14.5711 11.2799 14.3154 11 14 11C13.6846 11 13.4289 11.2799 13.4289 11.625V12.032C12.1171 12.3301 11.1443 13.5449 11.1443 15.0625C11.1443 17.0605 10.4988 17.6705 10.1538 18.076C10.0466 18.202 9.99912 18.3525 10 18.5C10.002 18.8203 10.2318 19.125 10.5732 19.125H17.4268C17.7682 19.125 17.9982 18.8203 18 18.5C18.0009 18.3525 17.9534 18.2018 17.8462 18.076Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'system-log',
    iconData: `<svg width='18' height='23' viewBox='0 0 21 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M11 13H4V15H11M16 18H2V7H16M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM14 9H4V11H14V9Z' fill='currentColor'/>
<path d='M21 16C21 19.866 17.866 23 14 23C10.134 23 7 19.866 7 16C7 12.134 10.134 9 14 9C17.866 9 21 12.134 21 16Z' fill='white'/>
<path d='M17.8951 18.5347L14.5886 15.2121C14.9184 14.3713 14.7334 13.3851 14.0415 12.6979C13.3175 11.9622 12.2314 11.8167 11.3545 12.2209L12.9152 13.7893L11.8291 14.8887L10.2281 13.3123C9.79371 14.1935 9.99483 15.2849 10.7028 16.0205C11.0223 16.3481 11.4301 16.5746 11.8761 16.6723C12.3221 16.7699 12.7867 16.7345 13.2129 16.5703L16.5194 19.8848C16.6642 20.0384 16.8814 20.0384 17.0262 19.8848L17.8629 19.0521C18.0399 18.9066 18.0399 18.6479 17.8951 18.5347Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'server-network',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M11 16H12C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17H20V19H13C13 19.2652 12.8946 19.5196 12.7071 19.7071C12.5196 19.8946 12.2652 20 12 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19H0V17H7C7 16.7348 7.10536 16.4804 7.29289 16.2929C7.48043 16.1054 7.73478 16 8 16H9V14H2C1.73478 14 1.48043 13.8946 1.29289 13.7071C1.10536 13.5196 1 13.2652 1 13V9C1 8.73478 1.10536 8.48043 1.29289 8.29289C1.48043 8.10536 1.73478 8 2 8H18C18.2652 8 18.5196 8.10536 18.7071 8.29289C18.8946 8.48043 19 8.73478 19 9V13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14H11V16ZM2 0H18C18.2652 0 18.5196 0.105357 18.7071 0.292893C18.8946 0.48043 19 0.734784 19 1V5C19 5.26522 18.8946 5.51957 18.7071 5.70711C18.5196 5.89464 18.2652 6 18 6H2C1.73478 6 1.48043 5.89464 1.29289 5.70711C1.10536 5.51957 1 5.26522 1 5V1C1 0.734784 1.10536 0.48043 1.29289 0.292893C1.48043 0.105357 1.73478 0 2 0ZM7 4H8V2H7V4ZM7 12H8V10H7V12ZM3 2V4H5V2H3ZM3 10V12H5V10H3Z' fill='currentColor'/>
</svg>`
  },
  {
    iconName: 'collector-server',
    iconData: `<svg width='12' height='20' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M10.2134 0.666664H1.78675C1.48971 0.666664 1.20483 0.784664 0.994788 0.994705C0.784748 1.20475 0.666748 1.48962 0.666748 1.78666V19.3333H11.3334V1.78666C11.3334 1.48962 11.2154 1.20475 11.0054 0.994705C10.7953 0.784664 10.5105 0.666664 10.2134 0.666664ZM6.00008 16.5267C5.76465 16.524 5.53525 16.4518 5.34077 16.3191C5.14629 16.1864 4.99542 15.9991 4.90714 15.7808C4.81886 15.5626 4.79712 15.3231 4.84466 15.0925C4.8922 14.8619 5.00689 14.6505 5.1743 14.4849C5.34171 14.3194 5.55436 14.207 5.78547 14.162C6.01658 14.1171 6.25583 14.1415 6.47311 14.2322C6.69039 14.3229 6.87598 14.4758 7.00652 14.6718C7.13707 14.8677 7.20673 15.0979 7.20675 15.3333C7.20587 15.4909 7.17397 15.6468 7.11286 15.792C7.05174 15.9373 6.96262 16.0691 6.85057 16.1799C6.73852 16.2907 6.60574 16.3784 6.45981 16.4379C6.31389 16.4974 6.15767 16.5275 6.00008 16.5267ZM9.33341 5.06666H2.66675V4H9.33341V5.06666Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'companies',
    iconData: `<svg width='18' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M16 12H14V14H16M16 8H14V10H16M18 16H10V14H12V12H10V10H12V8H10V6H18M8 4H6V2H8M8 8H6V6H8M8 12H6V10H8M8 16H6V14H8M4 4H2V2H4M4 8H2V6H4M4 12H2V10H4M4 16H2V14H4M10 4V0H0V18H20V4H10Z' fill='currentColor'/>
    </svg>`
  },
  {
    iconName: 'chirpstak-server',
    iconData: `<svg width='18' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path fill-rule='evenodd' clip-rule='evenodd' d='M5.70166 5.82349L5.74585 6.3963L5.17285 6.36053L5.16626 6.36023L5.13574 6.35901C5.10767 6.35815 5.06445 6.35724 5.0083 6.35736C4.96484 6.35748 4.91357 6.35822 4.85571 6.36011C4.76416 6.36316 4.65552 6.36914 4.53442 6.38C4.13647 6.41565 3.61621 6.50293 3.10376 6.70447C2.59229 6.90558 2.10645 7.21326 1.74829 7.68048C1.39453 8.14197 1.13818 8.79413 1.13818 9.73676C1.13818 11.8259 2.65601 13.1 4.52637 13.1414C5.35034 13.1596 5.92773 13.0237 6.30835 12.6776C6.59058 12.421 7.12598 11.9004 7.72437 11.3104C8.05176 10.9875 8.39819 10.6439 8.73218 10.3113C9.2019 9.84351 9.6438 9.40094 9.96851 9.07532L10.406 8.63586C10.312 8.44397 10.259 8.22815 10.259 8C10.259 7.20129 10.9065 6.55383 11.7051 6.55383C12.5039 6.55383 13.1514 7.20129 13.1514 8C13.1514 8.79871 12.5039 9.44617 11.7051 9.44617C11.5002 9.44617 11.3054 9.40363 11.1289 9.32684L10.6768 9.78125C10.3516 10.1074 9.90869 10.5509 9.43774 11.0199C8.50049 11.9532 7.43848 13.0013 6.9812 13.4174C6.31079 14.0271 5.40649 14.1611 4.50415 14.1411C2.15918 14.0894 0.138184 12.436 0.138184 9.73676C0.138184 8.59943 0.452393 7.72723 0.95459 7.07208C1.45239 6.42267 2.10791 6.02155 2.73755 5.77386C3.36646 5.52655 3.9873 5.42499 4.44531 5.38397C4.49487 5.37958 4.54272 5.37585 4.58862 5.37268C4.62622 5.37012 4.66284 5.36792 4.698 5.36609L4.69995 5.3042L4.7041 5.21301C4.70752 5.1427 4.71216 5.06812 4.71826 4.98975C4.76001 4.45935 4.87134 3.74158 5.15454 3.01569C5.43848 2.28833 5.90186 1.53638 6.65625 0.966919C7.41577 0.393799 8.43286 0.0335083 9.77222 0.0335083C11.1711 0.0335083 12.2322 0.678528 12.9272 1.29736C13.2759 1.60767 13.5393 1.91724 13.7163 2.14996C13.7756 2.2276 13.8254 2.29718 13.8657 2.35583L13.9182 2.36713C14.0852 2.40381 14.3164 2.46216 14.5754 2.54956C15.0801 2.71985 15.7478 3.01929 16.2292 3.53253C16.8071 4.1488 17.1079 4.84766 17.2649 5.38251C17.3362 5.62592 17.3792 5.83929 17.4045 6.00159C17.4473 6.02063 17.4934 6.04205 17.5422 6.06616C17.8005 6.19336 18.1436 6.39648 18.4873 6.70312C19.1853 7.32587 19.8662 8.35968 19.8662 9.9718C19.8662 11.8703 18.8572 12.9359 17.8623 13.5012C17.374 13.7787 16.8906 13.9366 16.532 14.0256C16.4619 14.043 16.3962 14.0579 16.3357 14.0706C16.2407 14.0905 16.1587 14.105 16.0925 14.1154C16.0383 14.1238 15.9949 14.1296 15.9636 14.1334L15.9263 14.1376L15.9148 14.1387L15.9109 14.1391C15.9109 14.1391 15.9092 14.1392 15.8965 14.0012L15.9084 14.1393L15.8865 14.1412H12.2119C12.0088 14.6945 11.4775 15.0891 10.854 15.0891C10.0552 15.0891 9.40771 14.4417 9.40771 13.6429C9.40771 12.8442 10.0552 12.1968 10.854 12.1968C11.4763 12.1968 12.0068 12.5898 12.2107 13.1412H15.8376L15.844 13.1406C15.864 13.1381 15.8958 13.134 15.9375 13.1274C15.9727 13.1219 16.0149 13.1147 16.063 13.1055C16.1287 13.0928 16.2056 13.0764 16.291 13.0551C16.5894 12.9811 16.9812 12.8517 17.3682 12.6318C18.124 12.2023 18.8662 11.4332 18.8662 9.9718C18.8662 8.6803 18.3352 7.90741 17.8215 7.4494C17.5596 7.21564 17.2966 7.05988 17.1006 6.96326C17.0027 6.91516 16.9229 6.88232 16.8699 6.86224C16.8435 6.85223 16.8237 6.84546 16.812 6.84155L16.8013 6.83801L16.4587 6.73773L16.4434 6.38196L16.4429 6.37549L16.4402 6.34131C16.4373 6.3092 16.4319 6.2594 16.4226 6.19507C16.4153 6.1441 16.4053 6.08441 16.3921 6.01746C16.3718 5.91479 16.3438 5.7951 16.3054 5.664C16.1775 5.22803 15.939 4.685 15.4998 4.21661C15.1855 3.88171 14.7026 3.64795 14.2556 3.49701C14.1538 3.46271 14.0571 3.43365 13.9685 3.4093C13.8679 3.38171 13.7781 3.36017 13.7036 3.34381C13.634 3.32855 13.5784 3.31793 13.5415 3.31134L13.5007 3.30438L13.4919 3.30304L13.252 3.26819L13.1313 3.06L13.1221 3.0448C13.1143 3.0321 13.1016 3.01184 13.084 2.98505C13.0486 2.9314 12.9941 2.85199 12.9207 2.75549C12.7732 2.56171 12.5525 2.30261 12.2625 2.04425C11.6799 1.52576 10.8457 1.03351 9.77222 1.03351C8.62158 1.03351 7.823 1.33923 7.25879 1.76508C6.6897 2.19464 6.32202 2.77466 6.08618 3.37927C5.84961 3.98541 5.7522 4.59961 5.71533 5.06824C5.70654 5.1795 5.70117 5.28168 5.69824 5.37262C5.69482 5.47198 5.69434 5.55786 5.69507 5.62738C5.6958 5.69391 5.69775 5.74518 5.69922 5.77875L5.70117 5.81525L5.70166 5.82349ZM11.7051 8.44617C11.9517 8.44617 12.1514 8.2464 12.1514 8C12.1514 7.7536 11.9517 7.55383 11.7051 7.55383C11.4587 7.55383 11.259 7.7536 11.259 8C11.259 8.2464 11.4587 8.44617 11.7051 8.44617ZM11.3 13.6429C11.3 13.8893 11.1003 14.0891 10.854 14.0891C10.6074 14.0891 10.4077 13.8893 10.4077 13.6429C10.4077 13.3965 10.6074 13.1968 10.854 13.1968C11.1003 13.1968 11.3 13.3965 11.3 13.6429Z' fill='currentColor'/>
<path fill-rule='evenodd' clip-rule='evenodd' d='M12.5285 5.20527C12.5173 5.47969 12.7295 5.71147 13.0032 5.72504Z' fill='currentColor'/>
<path d='M13.0485 4.72607C12.7726 4.71481 12.5398 4.92935 12.5285 5.20527C12.5173 5.47969 12.7295 5.71147 13.0032 5.72504L13.0048 5.72516C13.0084 5.72543 13.0163 5.72611 13.0278 5.72747C13.051 5.73021 13.0882 5.73565 13.1352 5.74594C13.2305 5.76683 13.3575 5.80594 13.4862 5.87708C13.7254 6.00915 14.0031 6.26526 14.0769 6.83443C14.1124 7.10828 14.3632 7.30148 14.6371 7.26597C14.9109 7.23045 15.1041 6.97966 15.0686 6.70581C14.9493 5.78567 14.4547 5.26956 13.9697 5.00172C13.7365 4.8729 13.5135 4.80514 13.3494 4.76914C13.2666 4.751 13.1968 4.74049 13.1453 4.7344C13.1195 4.73134 13.0981 4.72938 13.0818 4.72812L13.0611 4.72671L13.0538 4.72631L13.0509 4.72617L13.0496 4.72612L13.0485 4.72607Z' fill='currentColor'/>
<path fill-rule='evenodd' clip-rule='evenodd' d='M13.6183 0.508039C13.6324 0.232255 13.8674 0.0200969 14.1432 0.0341698C16.2311 0.140712 17.6164 1.1801 18.4798 2.36836C19.3301 3.53864 19.684 4.86249 19.7433 5.6234C19.7647 5.8987 19.5589 6.13928 19.2836 6.16073C19.0083 6.18218 18.7677 5.97639 18.7463 5.70108C18.6999 5.10524 18.4018 3.96228 17.6708 2.95616C16.9528 1.96802 15.8275 1.12142 14.0922 1.03287C13.8164 1.0188 13.6043 0.783822 13.6183 0.508039Z' fill='currentColor'/>
</svg>
`
  },
  /* {
     iconName: 'nbiot-server',
     iconData: `<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
 <path d='M15 2.25001C15.0002 2.57734 14.929 2.90078 14.7913 3.19776C14.6536 3.49473 14.4528 3.7581 14.2029 3.96947C13.953 4.18084 13.6599 4.33514 13.3442 4.42159C13.0285 4.50804 12.6977 4.52456 12.375 4.47001L11.4405 6.15301C12.1605 6.77101 12.645 7.65901 12.735 8.66101L13.725 8.77051C13.9564 8.29285 14.3491 7.91237 14.8339 7.6963C15.3187 7.48024 15.8643 7.44251 16.3742 7.58977C16.8841 7.73704 17.3255 8.05983 17.6205 8.50108C17.9154 8.94234 18.0449 9.47366 17.986 10.0011C17.9271 10.5286 17.6836 11.0183 17.2986 11.3836C16.9136 11.7489 16.4118 11.9664 15.882 11.9975C15.3521 12.0287 14.8283 11.8716 14.4032 11.5539C13.978 11.2362 13.6788 10.7784 13.5585 10.2615L12.57 10.152C12.2836 11.0365 11.6798 11.7836 10.875 12.249L11.2905 13.5C11.8211 13.5098 12.3312 13.7069 12.7306 14.0564C13.13 14.406 13.393 14.8854 13.4731 15.4101C13.5532 15.9348 13.4452 16.4709 13.1683 16.9236C12.8914 17.3764 12.4633 17.7167 11.9597 17.8844C11.4561 18.0521 10.9095 18.0363 10.4164 17.84C9.92334 17.6436 9.51554 17.2792 9.26511 16.8113C9.01467 16.3433 8.93772 15.8019 9.04785 15.2827C9.15799 14.7635 9.44812 14.3 9.86696 13.974L9.44996 12.723C8.83702 12.7981 8.21502 12.7203 7.63946 12.4965C7.06391 12.2727 6.55271 11.9099 6.15146 11.4405L4.46846 12.375C4.55702 12.8983 4.45773 13.4361 4.18813 13.8933C3.91853 14.3505 3.49599 14.6977 2.99518 14.8734C2.49437 15.0492 1.94754 15.0423 1.45134 14.8539C0.955139 14.6655 0.541516 14.3078 0.283575 13.8439C0.0256334 13.38 -0.0600185 12.8399 0.0417573 12.319C0.143533 11.7981 0.426184 11.3299 0.839753 10.9972C1.25332 10.6646 1.77118 10.4888 2.3018 10.501C2.83243 10.5132 3.34165 10.7127 3.73946 11.064L5.42246 10.1295C5.25437 9.59662 5.20754 9.03288 5.2854 8.47956C5.36326 7.92624 5.56384 7.39732 5.87246 6.93151L4.72046 5.78101C4.24152 6.00978 3.69712 6.06187 3.18349 5.92806C2.66985 5.79426 2.22006 5.48318 1.9136 5.04982C1.60715 4.61645 1.46376 4.08869 1.5088 3.55983C1.55383 3.03097 1.78438 2.53505 2.15969 2.15974C2.53501 1.78442 3.03092 1.55387 3.55979 1.50884C4.08865 1.46381 4.6164 1.60719 5.04977 1.91365C5.48314 2.2201 5.79422 2.6699 5.92802 3.18353C6.06182 3.69716 6.00973 4.24156 5.78096 4.72051L6.93146 5.87101C7.39691 5.56154 7.92592 5.36058 8.47944 5.28295C9.03296 5.20532 9.59685 5.25301 10.1295 5.42251L11.064 3.73951C10.8228 3.46663 10.6515 3.13929 10.5647 2.78561C10.478 2.43193 10.4784 2.06247 10.5659 1.70897C10.6534 1.35548 10.8254 1.0285 11.0671 0.756119C11.3088 0.483742 11.613 0.274106 11.9536 0.145215C12.2942 0.0163243 12.661 -0.0279697 13.0225 0.0161376C13.384 0.0602449 13.7293 0.191435 14.029 0.398441C14.3286 0.605448 14.5734 0.882084 14.7426 1.20459C14.9117 1.5271 15 1.88584 15 2.25001Z' fill='currentColor'/>
 </svg>
 `
   },*/
  {
    iconName: 'notification-server',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M10 16.5C10.4167 16.5 10.771 16.354 11.063 16.062C11.355 15.77 11.5007 15.416 11.5 15H8.5C8.5 15.4167 8.646 15.771 8.938 16.063C9.23 16.355 9.584 16.5007 10 16.5ZM5 14H15V12H14V9.4C14 8.38333 13.7373 7.454 13.212 6.612C12.6867 5.77 11.9493 5.23267 11 5V4.5C11 4.21667 10.904 3.979 10.712 3.787C10.52 3.595 10.2827 3.49933 10 3.5C9.71667 3.5 9.479 3.596 9.287 3.788C9.095 3.98 8.99933 4.21733 9 4.5V5C8.05 5.23333 7.31267 5.771 6.788 6.613C6.26333 7.455 6.00067 8.384 6 9.4V12H5V14ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z' fill='currentColor'/>
</svg>
`
  },
  {
    iconName: 'widgets-outline',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M13.7 3.5L16.5 6.3L13.7 9.1L10.9 6.3L13.7 3.5ZM6 4V8H2V4H6ZM16 14V18H12V14H16ZM13.7 0.699997L8 6.3L13.7 12H10V20H18V12H13.7L19.3 6.3L13.7 0.699997ZM8 2H0V10H8V2ZM6 14V18H2V14H6ZM8 12H0V20H8V12Z' fill='currentColor'/>
</svg>

`
  },
  {
    iconName: 'widgets',
    iconData: `<svg width='18' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M0 2H8V6.34L13.66 0.690002L19.31 6.34L13.66 12H18V20H10V12H13.66L8 6.34V10H0V2ZM0 12H8V20H0V12Z' fill='currentColor'/>
</svg>

`
  },

];


const gettext = (a) => a;

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() onSidebarStateChange = new EventEmitter<boolean>();
  public menuArray: MenuItemLocal[];
  public appMenuArray: MenuItemLocal[];
  public applications: ApplicationModel[];
  favoriteMenuArray: MenuItemLocal[];
  public menuType: FavoriteType;
  @HostBinding('class') classes = 'c-sidebar t-sidebar';
  // @ts-ignore
  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay: CdkConnectedOverlay;


  public hotKey = [];
  @HostListener('window:resize', ['$event'])
  onResize = _.throttle((event) => {
    this.checkSize();
  }, 100);

  public isMenuCollapsed = this.menuService.isCollapsed;
  public isMenuClosed = this.menuService.isCollapsed;
  public isDesktop = false;
  menufilter: any = '';
  public init = false;
  selIndex = 0;
  /*@HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      const value = this.menuService.isCollapsed.getValue();
      if (this.menuService.isCollapsed.getValue()) {
        this.init = !this.init;
        this.menuService.isCollapsed.next(true);
      } else if (this.init) {
        this.init = !this.init;
        this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
      } else {
        this.init = !this.init;
      }
    } else if (!this.menuService.isCollapsed.getValue()) {
      if (event.target.parentElement.className === 'c-main-menu__item-symbol') {
        this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
      }
      //this.init = !this.init;
      //this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
    }

  }*/
  public connectionPositionPairs: ConnectionPositionPair[] = [
    new ConnectionPositionPair({originX: 'end', originY: 'top'}, {overlayX: 'start', overlayY: 'top'}, 0, 0)
  ];
  private destroy$ = new Subject<boolean>();
  private choosenServices = ['All services', 'Pinned services', 'Not allocated services'];
  private selectSection = 'Select section';

  constructor(private router: Router,
              private menuService: MenuService,
              private authService: AuthService,
              private localStorageApi: LocalStorageService,
              private translateService: TranslateService,
              private eRef: ElementRef,
              private cdr: ChangeDetectorRef,
              private sanitizer: DomSanitizer,
              private favoritesApiService: FavoritesApiService,
              private messageService: InsparkMessageService,
              private applicationsApi: ApplicationsApiService,
              private configureService: ConfigureService,
              public mainTempService: MainTempService
  ) {
    this.menuType = FavoriteType.MENU;
    this.applicationsApi.getAllWithCache().subscribe(data => this.applications = data);
  }


  ngOnDestroy() {
    this.destroy$.next(true);
  }

  ngOnInit() {
    this.menuService.menu.subscribe(items => {
      this.menuArray = [];
      this.appMenuArray = [
        {
          id: 1000,
          iconCss: 'in in-store',
          title: gettext('MENU_STORE.MAIN'),
          apiList: [ApiList.ExWidget],
          children: [
            {
              id: 1001,
              pathArray: ['store'],
              apiList: [ApiList.ExWidget],
              // visibility: `sysuser`,
              minPrivilegy: 'update',
              title: gettext('MENU_STORE.LIST'),
              iconCss: 'in in-widgets-outline',
            },
            {
              id: 1002,
              pathArray: ['store', 'my'],
              apiList: [ApiList.ExWidget],
              minPrivilegy: 'update',
              // visibility: `sysuser`,
              title: gettext('MENU_STORE.MY'),
              iconCss: 'in in-widgets',
            },
          ],
        },
      ];
      items.slice().forEach((menuItem) => {
        if (menuItem.apiLists) {
          for (let i = 0; i < menuItem.apiLists.length; i++) {
            if (menuItem.apiLists[i].every(api => this.menuService.checkAccess(ApiList[api].toLowerCase(), menuItem.minPrivilegy || 'read'))) {
              this.menuArray.push(menuItem);
              break;
            }
          }
        } else if (menuItem.apiList) {
          if (menuItem.apiList.every(api => this.menuService.checkAccess(ApiList[api].toLowerCase(), menuItem.minPrivilegy || 'read'))) {
            this.menuArray.push(menuItem);
          }
        } else if (menuItem.children) {
          const tempMenuItem = Object.assign({}, menuItem, {
            children: menuItem.children.filter((_menuItem) => {
              if (_menuItem.apiLists) {
                for (let i = 0; i < _menuItem.apiLists.length; i++) {
                  if (_menuItem.apiLists[i].every(api => this.menuService.checkAccess(ApiList[api].toLowerCase(), _menuItem.minPrivilegy || 'read'))) {
                    return true;
                  }
                }
              } else if (_menuItem.apiList) {
                return _menuItem.apiList.every(api => this.menuService.checkAccess(ApiList[api].toLowerCase(), _menuItem.minPrivilegy || 'read'));
              } else {
                return true;
              }
            })
          });
          if (tempMenuItem.children.length > 0) {
            this.menuArray.push(tempMenuItem);
          }
        } else {
          this.menuArray.push(menuItem);
        }
      });
      this.initializeFavoriteMenu();
    });

    this.isMenuCollapsed.pipe(takeUntil(this.destroy$)).subscribe(
      isCollapsed => {
        this.filterMenu();
        this.menuArray.forEach(menu => {
          if (menu.children) {
            menu.state = false;
          }
        });
      });
  }

  private initializeFavoriteMenu() {
    const favoriteMenu = this.menuService.favoriteMenu;
    if (favoriteMenu) {
      try {
        const parsed = JSON.parse(favoriteMenu);
        if (parsed && parsed.description) {
          const visibleItems = JSON.parse(parsed.description) || [];
          if (this.menuArray?.length > 0) {
            this.menuArray.forEach((menuItem) => {
              if (menuItem.id) {
                menuItem.visible = visibleItems.includes(menuItem.id);
              }
              if (menuItem.children) {
                menuItem.children.forEach(child => {
                  child.visible = visibleItems.includes(child.id);
                });
              }
            });
          }
        }
      } catch (e) {
        console.warn('Failed to parse initial favorite menu, using empty state:', e);
      }
    } else {
      this.favoritesApiService.getAll(this.menuType).subscribe({
        next: (menuData) => {
          if (menuData && menuData.length > 0) {
            try {
              this.menuService.favoriteMenu = JSON.stringify(menuData[0]);
              const visibleMenu = JSON.parse(menuData[0].description) as number[];
              if (this.menuArray?.length > 0) {
                this.menuArray.forEach((menuItem) => {
                  if (menuItem.id) {
                    menuItem.visible = visibleMenu.includes(menuItem.id);
                  }
                  if (menuItem.children) {
                    menuItem.children.forEach(child => {
                      child.visible = visibleMenu.includes(child.id);
                    });
                  }
                });
              }
            } catch (e) {
              console.warn('Failed to parse favorite data from server:', e);
            }
          }
        },
        error: (err) => console.error('Error loading favorites:', err)
      });
    }
    this.favoriteMenuArray = _.cloneDeep(this.menuArray);
    this.cdr.detectChanges();
  }


  makeLink(givenLink?: string[]): string {
    let link = '';
    if (givenLink?.length > 0) {
      givenLink.forEach(l => {
        link += l + '/';
      });
    }
    return link;
  }

  addNewUser() {
    this.router.navigate(['/main', 'page', 'object']);
  }

  ngAfterViewInit() {
    this.checkSize();
  }

  public collapseMenu() {
    if (!this.isDesktop) {
      this.menuService.isCollapsed.next(true);
    }
  }

  public isActiveLink(location) {
    return this.menuService.isActiveLink(location);
  }

  public isActiveChild(menu: MenuItemLocal) {
    return menu.children.some(_menu => {
      if (this.menuService.isActiveLink(_menu.pathArray?.join('/'))) {
        return true;
      }
    });
  }

  public isActiveChild2(menu: MenuItemLocal) {
    return this.menuService.isActiveLink(menu.pathArray?.join('/'));
  }

  checkSize() {
    const isDesktop = window.innerWidth >= DESKTOP_WIDTH;

    if (this.isDesktop !== isDesktop) {
      this.isDesktop = isDesktop;
      this.cdr.detectChanges();
    }
  }

  // checkHotKey(link): string {
  //   if (link) {
  //     if (link === '/main/page/object/') {
  //       return 'Shift O';
  //     } else if (link === '/main/eventslog/') {
  //       return 'Ctrl E';
  //     } else if (link === '/main/page/charts/') {
  //       return 'Shift G';
  //     } else if (link === '/main/map/') {
  //       return 'Ctrl M';
  //     } else if (link === '/main/page/reports/') {
  //       return 'Ctrl R';
  //     } else if (link === '/main/page/analitics/dashboards/') {
  //       return 'Shift A';
  //     } else if (link === '/main/page/businessparams/') {
  //       return 'Ctrl B';
  //     } else if (link === '/main/page/businessevents/') {
  //       return 'Shift J';
  //     } else if (link === '/main/page/typicalconfig/') {
  //       return 'Shift T';
  //     } else if (link === '/main/page/controlprocedure/') {
  //       return 'Shift P';
  //     } else if (link === '/main/page/paramstates/') {
  //       return 'Shift H';
  //     } else if (link === '/main/page/event/') {
  //       return 'Ctrl V';
  //     } else if (link === '/main/page/scheduletemplate/') {
  //       return 'Ctrl S';
  //     } else if (link === '/main/page/zone/') {
  //       return 'Ctrl Z';
  //     } else if (link === '/main/geo/geozones/') {
  //       return 'Ctrl X';
  //     } else if (link === '/main/page/device/') {
  //       return 'Ctlr Y';
  //     } else if (link === '/main/dashboard/') {
  //       return 'Shift W';
  //     }
  //   }
  //   return;
  // }

  selectMenu(event, menu: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (menu.children?.length > 0) {
      menu.visible = !menu.visible;
      const flag = menu.visible;
      menu.children.forEach(m => m.visible = flag);
    } else {
      menu.visible = !menu.visible;
    }
    this.savefavoriteMenuInLocalStorage();
    this.saveOnServer();
  }

  scrollTo(elementId: string): void {
    (document.getElementById(elementId) as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }

  clickedOutsideOverlay(e) {
    if (!this.menuService.isCollapsed.getValue() && !(e.target.closest('.c-btn_menu-toggle') || e.target.closest('.main-menu__item-li'))) {
      this.menuService.isCollapsed.next(true);
      this.menufilter = '';
    }
  }

  // execMenu(event, menu: any) {
  //   event.stopPropagation();
  //   if (menu.queryParams$) {
  //     menu.queryParams$.subscribe(params => {
  //       // console.log('execMenu: ' + menu.title + ', params:  ' +  JSON.stringify(params));
  //       this.router.navigate(menu.pathArray, params);
  //     })
  //   } else {
  //     this.router.navigate(menu.pathArray);
  //   }
  //   // [queryParams]='child.queryParams$ ? (child.queryParams$ | async) : child.queryParams'
  //   //   [routerLink]='child.path$ ? (child.path$| async) : child.pathArray'
  //   this.menuService.isCollapsed.next(true);
  // }

  closeMenu() {
    this.menuService.isCollapsed.next(true);
    this.menufilter = '';
  }

  savefavoriteMenuInLocalStorage() {
    //const visiblemenu = JSON.stringify(this.menuArray.filter(menu => menu.visible === true));
    const menu = _.cloneDeep(this.menuArray);
    const visibleItems: number [] = [];

    let favoriteData: any = {};
    let allFavIds: number[] = [];

    try {
      if (this.menuService.favoriteMenu) {
        favoriteData = JSON.parse(this.menuService.favoriteMenu);
      }
    } catch (e) {
      console.warn('Failed to parse favoriteMenu in savefavoriteMenuInLocalStorage:', e);
      favoriteData = { description: '[]' };
    }

    try {
      allFavIds = JSON.parse(favoriteData.description) || [];
    } catch (e) {
      console.warn('Failed to parse description in savefavoriteMenuInLocalStorage:', e);
      allFavIds = [];
    }

    menu.forEach(menu => {
        if (menu.children) {
          menu.children.forEach(child => {
            if (child.visible) {
              visibleItems.push(child.id);
            } else if (allFavIds.includes(child.id)) {
              allFavIds = allFavIds.filter(_id => _id !== child.id);
            }
          });
          if (this.isVisibleChildren(menu.children) > 0) {
            visibleItems.push(menu.id);
          } else {
            allFavIds = allFavIds.filter(_id => _id !== menu.id);
          }
        } else {
          if (menu.visible) {
            visibleItems.push(menu.id);
          }
        }
      }
    );

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    const finalIds = [...allFavIds, ...visibleItems].filter(onlyUnique);
    const params: Omit<FavoriteModel, 'id'> = {
      url: '',
      description: JSON.stringify(finalIds),
      linkobjid: undefined,
      linktype: FavoriteType.MENU
    };
    const favoriteMenu = JSON.stringify(params);
    this.menuService.favoriteMenu = favoriteMenu;
  }

  saveOnServer() {
    let favoriteData: any = {};
    let allFavIds: number[] = [];

    try {
      if (this.menuService.favoriteMenu) {
        favoriteData = JSON.parse(this.menuService.favoriteMenu);
      }
    } catch (e) {
      console.warn('Failed to parse favoriteMenu in saveOnServer:', e);
      favoriteData = { description: '[]' };
    }

    try {
      allFavIds = JSON.parse(favoriteData.description) || [];
    } catch (e) {
      console.warn('Failed to parse description in saveOnServer:', e);
      allFavIds = [];
    }

    if (favoriteData && favoriteData.id) {
      const params: Omit<FavoriteModel, 'id'> = {
        url: '',
        description: JSON.stringify(allFavIds),
        linkobjid: undefined,
        linktype: FavoriteType.MENU
      };
      this.favoritesApiService.save(favoriteData.id, params).subscribe({
        next: () => {},
        error: (err) => console.error('Error saving favorite menu', err)
      });
    } else {
      this.favoritesApiService.getAll().subscribe({
        next: (favorites) => {
          let list = [];
          if (favorites) {
            list = (favorites as FavoriteModel[]).filter(fav => fav.linktype === FavoriteType.MENU);
          }
          if (list.length === 0) {
            const params: Omit<FavoriteModel, 'id'> = {
              url: '',
              description: JSON.stringify(allFavIds),
              linkobjid: undefined,
              linktype: FavoriteType.MENU
            };
            this.favoritesApiService.create(params).subscribe({
              next: () => {},
              error: (err) => console.error('Error creating favorite menu', err)
            });
          } else {
            const linkId = list[0].id;
            const params: Omit<FavoriteModel, 'id'> = {
              url: '',
              description: JSON.stringify(allFavIds),
              linkobjid: undefined,
              linktype: FavoriteType.MENU
            };
            this.favoritesApiService.save(linkId, params).subscribe({
              next: () => {},
              error: (err) => console.error('Error saving favorite menu', err)
            });
          }
        },
        error: (err) => console.error('Error fetching favorites for saveOnServer', err)
      });
    }
  }

  isVisibleChildren(children?: MenuItemLocal[]) {
    if (children) {
      const found = children.filter(child => child.visible);
      return found.length;
    }
    return 0;
  }

  getVisibleChildren(children?: MenuItemLocal[]) {
    return children.filter(child => child.visible)[0];
  }


  clearfavoriteMenu() {
    this.localStorageApi.remove(true, 'favoriteMenu');
    this.menuService.favoriteMenu = '';
    this.cdr.detectChanges();
  }

  gotoMainApp() {
    window.document.location.href = '/#!/main';
  }

  private filterMenu() {
    let mmm = [];
    this.menuArray.forEach(menu => {
      let found = [];
      if (menu.children) {
        found = menu.children.filter(child => {
          const trns = this.translateService.instant(child.title);
          if (trns.toLowerCase().includes(this.menufilter.toLowerCase()) || child.title.toLowerCase().includes(this.menufilter.toLowerCase())) {
            delete child.filtered;
          } else {
            child.filtered = true;
          }
        });
      }
    });
  }

  private clear() {
    this.menufilter = '';
    this.filterMenu();
  }

  private chooseService() {
    this.selIndex = (this.selIndex + 1) % 3;
  }

  private filter(children) {
    if (!children) {
      return [];
    }
    return children.filter(child => this.filterFastenHeader(child));
  }

  private filterFastenHeader(header) {
    if (header.filtered) {
      return false;
    }
    if (this.selIndex === 0) {
      return true;
    }
    if (header.children) {
      for (let i = 0; i < header.children.length; i++) {
        if (this.selIndex === 1) {
          if (header.children[i].visible) {
            return true;
          }
        } else if (this.selIndex === 2) {
          if (!header.children[i].visible) {
            return true;
          }
        }
      }
    } else {
      return this.selIndex === 1 ? header.visible : !header.visible;
    }
    return false;
  }
}
